module.exports = __webpack_public_path__ + "img/icon_error.1ac87c14.svg";